"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiMethods = void 0;
var ApiMethods = /** @class */ (function () {
    function ApiMethods() {
    }
    ApiMethods.logIn = 'LogIn';
    ApiMethods.logOut = 'LogOut';
    ApiMethods.getItemPreview = 'GetItemPreview';
    return ApiMethods;
}());
exports.ApiMethods = ApiMethods;
